let Url, ApiUrl, AppUrl, BaseUrl, resourceUrl;
let domainUrl = 'okzhuan.com';
if (process.env.NODE_ENV === 'development' || (window.location.host).indexOf('lkdev-') > -1) {
    ApiUrl = 'https://lkdev-api.' + domainUrl + '/';
    AppUrl = 'https://lkdev-app.' + domainUrl + '/';
    BaseUrl = 'https://lkdev-www.' + domainUrl + '/';
    resourceUrl = '//lkdev-resource.' + domainUrl + '/';
} else {
    ApiUrl = 'https://api.' + domainUrl + '/';
    AppUrl = 'https://app.' + domainUrl + '/';
    BaseUrl = 'https://www.' + domainUrl + '/';
    resourceUrl = '//resource.' + domainUrl + '/';
}
Url = 'www.' + domainUrl;
export {
    Url,
    ApiUrl,
    AppUrl,
    BaseUrl,
    resourceUrl
}
